module.exports = __webpack_public_path__ + "img/kartice.4530d564.png";